import ArticleSidebarContents from './ArticleSidebarContents';

function ArticleSidebar({
  headings = [],
  activeHeadingId = '',
  /* edit mode: the editor's controls take the place of the page contents */
  editorSidebar = null,
}) {
  // No editor panels and no headings: no sidebar at all.
  if (!editorSidebar && headings.length === 0) {
    return null;
  }

  return (
    <aside className="article-sidebar">
      <div className="article-sidebar-sticky">
        {editorSidebar || (
          <ArticleSidebarContents
            headings={headings}
            activeHeadingId={activeHeadingId}
          />
        )}
      </div>
    </aside>
  );
}

export default ArticleSidebar;
